import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=7e3602d0&scoped=true&lang=pug&"
var script = {}
import style0 from "./Warning.vue?vue&type=style&index=0&id=7e3602d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3602d0",
  null
  
)

export default component.exports